<template lang="pug">
.receipt(fluid)
	LoadingScreen(v-if='isLoading')
	Message(v-if="showMessage" :message="messageText" @hideMessage="hideMessage")
	.cContainer(v-else)
		.header(align-v="center")
			.back-cursor.mb-2(@click="$router.go(-1)")
				span
					BIconChevronLeft
				span Back
			h2.title Form Download Menu
		.body
			.spinner(v-if="!formsAvailable")
					b-spinner(variant="success" label="Spinning")
			.list-section(v-else)
				b-row
					b-col.rsection
						.Rlabel Forms
						b-form-checkbox(v-if="formsAvailable && formsAvailable.length > 0" v-for="(form, li) in formsAvailable" :key="li" v-model="formsToRun" :value="form" name="checkbox")
							.check {{ form }}
						.noforms(v-else) No Forms
				b-row
					b-col.rsection
						.Rlabel Export Method
						b-form-radio(v-for="(exportMethod, lk) in exportMethods" :key="lk" v-model="ExportMethod" :value="exportMethod" name="exports")
							.check {{ exportMethod }}
				b-row
					b-col
						.button.run-form(:class="{ disabled: !formsToRun.length }" @click='runForms') Get Form
</template>

<style lang="scss" scoped>
.header {
	font-family: $font-serif;
	text-align: left;
	height: 15vh;
	background: #e6f1ed;
	h2 {
		margin: 0;
	}
	p {
		margin: 1.0vmin 0 0 0;
		font-family: $font-sans-serif;
	}
	.title {
		text-align: left;
		font-weight: bold;
		font-size:5vmin;
	}
}
.rsection {
	min-width:180px;
}
.body {
	height: 85vh;
	text-align: left;
	overflow-y: scroll;
}
.list-section {
	width:80vw;
	height:65vh;
	text-align:left;
	margin: 5vh 10vw 5vh 10vw;
	overflow-xy:auto;
	.Rlabel {
		font-weight:600;
		color: #89B831;
		padding: 2.0vh 1vw 1vh 0;
	}
	.listQuestion {
		font-size: 4vmin;
	}
	.button {
		font-size:6vmin;
		background:blue;
		border-shadow:.1vh .1vh  white;
		margin:2vmin;
		border-radius: 5vmin;
		cursor:pointer;
		color:white;
		text-align:center;
	}
	.run-form {
		background:#89B831;
	}
		.disabled {
			background:grey;
			color: #555;
		}
	::v-deep .custom-control-label::before {
			border-radius: 3.0vmin;
			background: #E5EBB8 !important;
	}
	::v-deep .custom-control-input:checked ~ .custom-control-label::before {
		border-color: $color-primary !important;
		background-color:  $color-primary !important;
	}
}
.back-cursor {
	cursor: pointer;
	font-family: $font-sans-serif;
	font-weight: bold;
	font-size: 3vmin;
}

</style>

<script>
import axios from 'axios';
import { BIconChevronLeft, BIconEnvelope, BIconChevronRight } from 'bootstrap-vue';
import LoadingScreen from '@/components/LoadingScreen';
import Message from '@/components/Message';

export default {
	name : 'form-menu',

	components : {
		BIconChevronLeft,
		BIconChevronRight,
		LoadingScreen,
		Message,
	},

	props : {
		title : {
			type : String,
		},
	},

	data : () => ( {
		isLoading     : false,
		formats       : ["PDF File", "Excel Sheet"],
		exportMethods : ["Download", "Email", "View"],
		formsToRun : [],
		ExportMethod : "View",
		messageText  : "Email sent successfully.",
		showMessage  : false,
	} ),

	computed : {
		getSelectedContract() {
			return this.$store.getters.selectedContract;
		},
		formsAvailable() {
			return this.$store.getters.getFormsAvailable;
		}
	},

	async created() {
		await this.$store.dispatch('getFormsAvailable');
		console.log('created');
	},

	methods : {
		back() {
			this.$emit( 'back' );
		},
		onSelectYear(year) {
			this.yearSelected=year;
		},
		selectForm() {
			console.log(`Select Form`);
				const formTypes=this.formsToRun.map((x) => `formType=${encodeURI(x)}`).join('&');
				console.log(formTypes);
		},
		hideMessage() {
			this.showMessage=false;
		},
		runForms() {
			if(this.formsToRun.length) {
				let formTypes=[];
				const selectedContract=this.getSelectedContract.contractNum;
				let fUrl="";
				switch(this.ExportMethod) {
				case 'Email':
					this.isLoading=true;
					formTypes=this.formsToRun.map((x) => `formType[]=${encodeURI(x)}`).join('&');
					console.log(this.formTypes);
					fUrl = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_URL}/GDD/get-form`;
					console.log(fUrl);
					
					console.log(selectedContract);
					axios({
						url: fUrl,
						method: 'POST',
						responseType: 'application/json',
						data: {
							exportMethod: this.ExportMethod,
							FileName: this.formsToRun
						},
						headers: {
							'Auth-Token'   : this.$store.state.accessToken
						}
					}).then((response) => {
						this.showMessage=true;
					});
					this.isLoading=false;
					break;
				default:
					this.isLoading=true;
					fUrl = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_URL}/GDD/get-form`;
					if(this.ExportMethod === 'Download') {
						for(let formType of this.formsToRun) { //eslint-disable-line
							console.log(fUrl);
							console.log('check auth');
							axios({
								url: fUrl,
								method: 'POST',
								responseType: 'blob',
								data: {
									exportMethod: this.ExportMethod,
									FileName: [formType]
								},
								headers: {
									'Auth-Token'   : this.$store.state.accessToken
								}
							}).then((response) => {
								if(response.status!==200) {
									console.log('Handle Error');
								}
								const fileURL = window.URL.createObjectURL(new Blob([response.data]));
								const fileLink = document.createElement('a');
								fileLink.href = fileURL;
								fileLink.setAttribute('download', formType);
								document.body.appendChild(fileLink);
								fileLink.click();
								this.isLoading=false;
							})
							.catch((err) => {
								switch(err.code) {
								default: this.$parent.$parent.handleError(err.response.status, err.response.statusText); break;
								}
							});
						}
					} else {
						this.isLoading=true;
						let counter = 0;
						for(let formType of this.formsToRun) { //eslint-disable-line
							const j = this;
							setTimeout(function () {//eslint-disable-line
								const form = document.createElement('form');
								form.method='POST';
								form.target='_blank';
								form.action=fUrl;
								console.log(fUrl);

								const exportMethodElem=document.createElement('input');
								exportMethodElem.type = 'hidden';
								exportMethodElem.name = 'exportMethod';
								exportMethodElem.value = j.ExportMethod;
								form.appendChild(exportMethodElem);
								
								const formTypeElem=document.createElement('input');
								formTypeElem.type = 'hidden';
								formTypeElem.name = 'FileName';
								formTypeElem.value = formType;
								form.appendChild(formTypeElem);
								document.body.appendChild(form);
								console.log('submit form');
								form.submit();
							}, (1000*counter));
							counter++;
						}
						this.isLoading=false;

					}
					this.isLoading=false;
					break;
				}
			} else {
				console.log('form button is disabled');
			}
		},
	}
};
</script>
